import type {Record} from 'typings/portaro.be.types';

export class RecordMergeRequest {

    public constructor(public readonly target: Record,
                       public readonly sources: Record[],
                       public readonly mergeDetail?: boolean) {
    }
}